import { render, staticRenderFns } from "./RestoreEmployeeAccess.vue?vue&type=template&id=5c04774b&scoped=true"
import script from "./RestoreEmployeeAccess.vue?vue&type=script&lang=js"
export * from "./RestoreEmployeeAccess.vue?vue&type=script&lang=js"
import style0 from "./RestoreEmployeeAccess.vue?vue&type=style&index=0&id=5c04774b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c04774b",
  null
  
)

export default component.exports